import { AxiosMethods, RFQApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';
import {
  ImageBody,
  JobIdByUrlParams,
  ManufacturerBody,
  RfqProduct,
  TextBody,
  UrlBody
} from './types';

const body = {
  topK: 10,
  threshold: 0.5
};

const headers = {
  'Content-Type': 'application/json',
  Accept: 'text/plain'
};

export enum AutoRFQMutationKeys {
  GET_JOB_ID_BY_URL = 'get-job-id-by-url',
  GET_JOB_ID_BY_FILE = 'get-job-id-by-file',
  GET_PRODUCTS_BY_URL = 'get-products-by-url',
  GET_PRODUCTS_BY_TEXT = 'get-products-by-text',
  GET_PRODUCTS_BY_IMAGE_URL = 'get-products-by-image-url',
  GET_PRODUCT_SUMMARY = 'get-product-summary'
}

export const getJobIdByUrl = () => ({
  mutationFn: ({ url, ...rest }: JobIdByUrlParams) =>
    axiosHelper({
      endpoint: RFQApi.GetJobIdByUrl,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers,
      body: {
        ...body,
        ...rest,
        type: 'Standard',
        url
      }
    })
});

export const getJobIdByFile = () => ({
  mutationFn: (file: File) =>
    axiosHelper({
      endpoint: RFQApi.GetJobIdByFile,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers: {
        Accept: 'text/plain',
        'Content-Type': 'multipart/form-data'
      },
      params: {
        ...body,
        type: 'Custom1'
      },
      body: {
        file
      }
    })
});

export const getProductsByUrl = (signal?: AbortSignal) => ({
  mutationFn: (props: UrlBody) =>
    axiosHelper({
      endpoint: RFQApi.GetProductsByUrl,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers,
      signal,
      body: {
        ...props,
        type: 'Standard',
        ...body
      }
    })
});

export const getProductsByText = (signal?: AbortSignal) => ({
  mutationFn: (props: TextBody) =>
    axiosHelper({
      endpoint: RFQApi.GetProductsByText,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers,
      signal,
      body: {
        ...props,
        ...body
      }
    })
});

export const getProductsByImageUrl = (signal?: AbortSignal) => ({
  mutationFn: (props: ImageBody) =>
    axiosHelper({
      endpoint: RFQApi.GetProductsByImageUrl,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers,
      signal,
      body: {
        ...props,
        ...body
      }
    })
});

export const getProductsByManufacturer = (signal?: AbortSignal) => ({
  mutationFn: (props: ManufacturerBody) =>
    axiosHelper({
      endpoint: RFQApi.GetProductsByManufacturer,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers,
      signal,
      body: {
        ...props,
        ...body
      }
    })
});

export const getProductsSummaryMutation = () => ({
  mutationFn: (product: RfqProduct) =>
    axiosHelper({
      endpoint: RFQApi.GetProductDetails,
      method: AxiosMethods.POST,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers,
      body: {
        ...product,
        ...body
      }
    })
});
